// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--r3hJM","info":"_7a3fb80146--info--mywqS","link":"_7a3fb80146--link--GGXmT"};